import { Link } from "react-router-dom";

import "./NavigationButton.css";

function NavigationButton({ alt, img, isLoggedIn, route, teacherid }) {
  if (!isLoggedIn) {
    return null;
  }

  return (
    <Link to={route} state={{ teacherid }}>
      <img src={img} alt={alt} className="img-button" />
    </Link>
  );
}

export default NavigationButton;
